import React from 'react';
import HLSPlayer from './HLSPlayer';
import VideoPlayer from './VideoPlayer';

const SmartVideoPlayer = ({ video, onClose }) => {
  // Function to detect video format based on URL
  const getVideoFormat = (videoUrl) => {
    const url = videoUrl.toLowerCase();
    
    console.log('SmartVideoPlayer: Analyzing video URL:', videoUrl);
    
    if (url.includes('.m3u8') || url.includes('hls')) {
      console.log('SmartVideoPlayer: Detected HLS format');
      return 'hls';
    } else if (url.includes('.mp4') || url.includes('.mov') || url.includes('.avi') || url.includes('.webm')) {
      console.log('SmartVideoPlayer: Detected video format (MP4/MOV/AVI/WEBM)');
      return 'video';
    } else {
      console.log('SmartVideoPlayer: Unknown format, defaulting to video player');
      // Default to video player for unknown formats
      return 'video';
    }
  };

  const videoFormat = getVideoFormat(video.videoUrl);

  console.log('SmartVideoPlayer: Using player type:', videoFormat);

  // Render appropriate player based on format
  if (videoFormat === 'hls') {
    return <HLSPlayer video={video} onClose={onClose} />;
  } else {
    return <VideoPlayer video={video} onClose={onClose} />;
  }
};

export default SmartVideoPlayer; 